window.onload = function () {
  
  document.querySelectorAll('a[href*="wa.me"]').forEach(element => {
      element.classList.add("link-whatsapp");
      element.setAttribute("target", "_blank");
      element.addEventListener('click', function () {
          if (typeof gtag == 'function') {
              gtag('event', 'adw_click_whatsapp');
          };
          if (typeof ga == 'function') {
              ga('send', 'event', 'whatsapp', 'click', 'envio');
          };
      });
  });

}

const topMainContent = function() {
  let currAnnouncementBarHeight = $("#announcement_bar_custom").outerHeight();
  $("#MainContent").css("margin-top", `${currAnnouncementBarHeight - 2}px`);
}

const formsHeaderShow = function(el){
  $(".login-register-container > div:first-child > form").removeClass("active");
  if(el.hasClass("show-recover")){
     $(".login-register-container > div:first-child > form:last-child").addClass("active");
  }
  if(el.hasClass("show-login")){
     $(".login-register-container > div:first-child > form:first-child").addClass("active");
  }
}

const formPositionHeader = function() {
  let windowWidth = $(window).width();
  if(windowWidth > 989){
    let headerIconsRithOffset = (windowWidth - ($(".header__icons").offset().left + $(".header__icons").outerWidth()));
    $(".login-register-container").css({"right":`${headerIconsRithOffset}px`, "left": "auto"});
  }else{
    $(".login-register-container").css({"right":`auto`, "left": "0"});
  }
}

const openForms = function(){
  if($(".login-register-container").hasClass("active")){
    $(".login-register-container").removeClass("active");
  }else{
    $(".login-register-container").addClass("active");
  }
}

const leftMegaMenuContent = function(){
  let leftMenu = $("nav.header__inline-menu").offset().left;
  $(".mega-menu__content").css("padding-left", `calc(${leftMenu}px - 4rem)`);
}

const showMegaMenuSubmenu2 = function(el){
  el.parents(".custom-menu-links").find(".custom-menu-links_container__links > .mega-menu__link").removeClass("active");
  el.parents(".custom-menu-links").find(".custom-menu-links_container__menu-custom > ul").removeClass("active");
  el.addClass("active");
  let currHandle = el.attr("data-handle");
  $(`.custom-menu-links_container__menu-custom > ul[data-handle=${currHandle}]`).addClass("active");
}

const calculateQuantityTotal = function(){
  if($("#quantity__total").length > 0){
    let currQuantity = Number($('select[name="options[Quantity]"]').val());
    let currQuantityProducts = Number($('input[name="quantity"]').val());
    let total = ``;
    if(currQuantity > 0 && currQuantityProducts > 0){
      total = currQuantity * currQuantityProducts;
      
    }
    $("#quantity__total").text(total);
  }
}


$(function(){
  
  if($("body.index").length > 0){
    topMainContent();
  }
  
  $(".show-login, .show-recover").on("click", function(e){
    e.preventDefault();
    formsHeaderShow($(this));
  });

  formPositionHeader();
  leftMegaMenuContent();

  $(window).resize(function(){
    formPositionHeader();
    leftMegaMenuContent();
  });

  $(".open-menu-custom").on("click", function(){
    openForms();
  });

  $(".footer-block__heading__custom").on("click", function(){
    $(this).parent().toggleClass("active");
  });

  $(".custom-menu-links_container__links > .mega-menu__link").on("mouseover", function(){
    showMegaMenuSubmenu2($(this));
  });

  $(".octo-selected, .octo-selected-color").on("click", function(e){
    e.preventDefault();
  })

  $(" .product-form__quantity quantity-input .quantity__button").on("click", function(e){
     //calculateQuantityTotal();
  });

  $("header-menu > details > summary").on("click", function(e){
    let currUrl = $(this).attr("data-href");
    window.location.href = currUrl;
  });

  $('.klaviyo-bis-trigger-new').on('click', function() {
    console.log("ok")
    $(".klaviyo-bis-trigger").trigger("click");
  });

  if($("#read-more-content").length > 0){
    document.getElementById("read-more-content").style.maxHeight  = "55px";
    $('#read-more-btn').on('click', function(e) {
      e.preventDefault();
      toggleReadMore();
    });
  }
  
  //calculateQuantityTotal();
  
});

function toggleReadMore() {
  let content = document.getElementById("read-more-content");
  let button = document.getElementById("read-more-btn");

  if (content.style.maxHeight === "55px") {
    content.style.maxHeight = "3000px"; // Expands the content
    button.textContent = "Close";
  } else {
    content.style.maxHeight = "55px"; // Collapses the content
    button.textContent = "Read More";
  }
}